import axios from 'axios';
import { watch } from 'vue'
import { useRoute, useRouter } from "vue-router";
import i18n from "../../assets/lang/index";
import { ElMessage } from 'element-plus'
import { useDemoStore } from '../../pinia/index'
import { getRealJsonData } from '../../hooks/realJson'

const store = useDemoStore()
//光河（运输）
function getApiUrl() {
  let url = "";
  if (store.context == 0) {
    //测试环境
    url = "http://a-api.files99.com";
  } else if (store.context == 1) {
    if (store.server == "cn") {
      //中国
      url = "https://cn-a-api-produce.files99.com";
    } else if (store.server == "de") {
      //德国
      url = "https://de-a-api-produce.kernal.net";
    } else if (store.server == "usWest") {
      //美国(西部)
      url = "https://us-a-api-produce.kernal.net";
    } else if (store.server == "usEst") {
      //美国(东部)
      url = "https://use-a.salesdeep.com";
    } else if (store.server == "br") {
      //巴西
      url = "https://br-a-api-produce.kernal.net";
    } else if (store.server == "sg") {
      //新加坡
      url = "https://sg-a-api-produce.kernal.net";
    }
  } else if (store.context == 2) {
    //生产
    if (store.server == "cn") {
      //中国
      url = "https://cn-a-api-produce.files99.com";
    } else if (store.server == "de") {
      //德国
      url = "https://de-a.salesdeep.com";
    } else if (store.server == "usWest") {
      //美国(西部)
      url = "https://us-a.salesdeep.com";
    } else if (store.server == "usEst") {
      //美国(东部)
      url = "https://use-a.salesdeep.com";
    } else if (store.server == "br") {
      //巴西
      url = "https://br-a.salesdeep.com";
    } else if (store.server == "sg") {
      //新加坡
      url = "https://sg-a.salesdeep.com";
    }
  }
  return url;
}

export const headerUrl = getApiUrl()
// 创建一个 axios 实例
export const service = axios.create({
    baseURL: getApiUrl(),
    timeout: 30000, // 请求超时时间
    headers: { 'Cache-Control': 'no-cache' },
    // withCredentials: true // 开启后服务器才能获取cookie
    transformResponse: [
        (data) => {
            // 使用JSONbig对返回的数据进行处理
            return getRealJsonData(data);

        },
    ],
})

watch(() => store.server, (newVal) => {
    service.defaults.baseURL = getApiUrl()
})


// 请求拦截器
service.interceptors.request.use(
    config => {
        config.headers["codeKey"] = store.codeKey;
        return config;
    },
    error => {
        return Promise.error(error);
    })

// 响应拦截器
service.interceptors.response.use(
    response => {
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
        if (response.status == 200) {
            //Status：0——正确数据，1000——token过期，其他为错误
            const { Status, Message } = response.data
            if (Status == 1000) {
                //token过期
                ElMessage.error(i18n.global.t("com.loginExpired"));
                location.reload();
            }
            if (Status != 1000 && Status != 0) {
                ElMessage.error(Message);
            }
            return Promise.resolve(response);
        } else {
            ElMessage.error(response.message);
            return Promise.reject(response);
        }
    },
    error => {
        if (error.message.includes('timeout')) {
            ElMessage.error(i18n.global.t("com.resTime"));
        } else if (error.response?.status == 404) {
            ElMessage.error(i18n.global.t("com.res404"));
        } else if (error.response?.status == 500) {
            ElMessage.error(i18n.global.t("com.res500"));
        } else {
            // 其他错误，直接抛出错误提示
            ElMessage.error(i18n.global.t("com.resOther") + error.message);
        }
        return Promise.reject(error);
    }
);

function getToken() {
    const store = useDemoStore()
    let token = store ? store.token : ''//保证每次请求都是拿到最新的token
    return token
}
function getLang() {
    const lang = useDemoStore()
    let str = lang.lang//保证每次请求都是拿到最新的
    return str
}
/**
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 *  @param {Boolean} tokenType [是否在头部传token]
 * get的第二个参数是一个{}，然后这个对象的params属性值是一个参数对象的。而post的第二个参数就是一个参数对象。
 */
export function get(url, params, tokenType = false) {
    return new Promise((resolve, reject) => {
        let headers = { 'Accept-Language': getLang() }
        if (tokenType) {
            headers['Authorization'] = getToken()
        }
        service.get(url, {
            params: params,
            headers: headers
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data)
        })
    });
}
//参数为表单方式提交
export function post(url, params, tokenType = false) {
    return new Promise((resolve, reject) => {
        var headers = { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', 'Accept-Language': getLang() } }
        if (tokenType) {
            headers.headers['Authorization'] = getToken()
        }
        service.post(url, params, headers)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
//参数为json方式提交
export function postJson(url, params, tokenType = false) {
    return new Promise((resolve, reject) => {

        var headers = { headers: { 'Content-Type': 'application/json;charset=UTF-8', 'Accept-Language': getLang() } }
        if (tokenType) {
            headers.headers['Authorization'] = getToken()
        }
        service.post(url, params, headers)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
//type可以自己传 application/x-www-form-urlencoded;charset=UTF-8、application/json;charset=UTF-8、multipart/form-data
export function postType(url, params, tokenType = false, type = 'application/x-www-form-urlencoded;charset=UTF-8') {
    return new Promise((resolve, reject) => {
        var headers = { headers: { 'Content-Type': type, 'Accept-Language': getLang() } }
        if (tokenType) {
            headers.headers['Authorization'] = getToken()
        }
        service.post(url, params, headers)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}